import React, { useEffect, useState } from 'react';
import { Table, Button, Drawer, message, Space, Input, Popconfirm, Image } from 'antd';
import axios from 'axios';
import MonkForm from './MonkForm';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/api';

const MonksPage = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [monks, setMonks] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editingMonk, setEditingMonk] = useState(null);
  const [searchText, setSearchText] = useState('');

  // const filterByProvince = async (dataArray, provinceName) => {
  //   return dataArray.filter(item => item.province === provinceName);
  // }

  const filterByProvince = async (dataArray, provinceName) => {
    const filtered = dataArray.filter(item => item.province === provinceName);

    // เพิ่ม index เป็นลำดับที่ 1, 2, 3, ...
    return filtered.map((item, index) => ({
      ...item,
      index: index + 1,
    }));

  };


  const fetchMonks = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/api/monks`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const userDataRes = await axios.get(`${API_BASE_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const profileData = { ...userDataRes.data, address: { province: userDataRes.data.province, district: userDataRes.data.district, subdistrict: userDataRes.data.subdistrict } };

      const province = profileData.province;

      // เรียกใช้ฟังก์ชัน
      const filteredItems = await filterByProvince(res.data, province);

      console.log('index', filteredItems);

      //กรณีเป็นจังหวัด จะได้ข้อมูลจังหวัดนั้นๆพอ
      if (profileData.level === 'จังหวัด') {
        setMonks(filteredItems);
      } else if (profileData.level == 'ภาค') {
        // เรียกใช้ฟังก์ชัน
        const filteredItems = res.data.map((item, index) => ({
          ...item,
          index: index + 1,
        }));
        setMonks(filteredItems);
      }

    } catch (err) {
      message.error('โหลดข้อมูลพระไม่สำเร็จ');
    }
  };

  useEffect(() => {
    fetchMonks();
  }, []);

  const handleEdit = (monk) => {
    setEditingMonk(monk);
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setEditingMonk(null);
    setOpenDrawer(false);
    fetchMonks();
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/monks/${id}`);
      message.success('ลบข้อมูลเรียบร้อย');
      fetchMonks();
    } catch {
      message.error('ไม่สามารถลบข้อมูลได้');
    }
  };

  const createAndShareFolder = async ({ username, password, folderName }) => {
    const baseUrl = 'https://cloud.atom-soft.com'; // เปลี่ยนเป็นโดเมนของคุณ
    const targetUrl = `${baseUrl}/remote.php/dav/files/${username}/Documents/${folderName}/`;
    //https://cloud.atom-soft.com/remote.php/dav/files/sangha

    try {
      const response = await axios({
        method: 'MKCOL',
        url: targetUrl,
        auth: {
          username: username,
          password: password // แนะนำให้ใช้ App Password
        },
        headers: {
          'Content-Type': 'application/xml'
        }
      });

      if (response.status === 201) {
        console.log('สร้างโฟลเดอร์สำเร็จ');
      } else {
        console.log('สถานะการตอบกลับ:', response.status);
      }
    } catch (error) {
      console.error('เกิดข้อผิดพลาด:', error.response?.status, error.response?.data);
    }
  };

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: 'รูป', dataIndex: 'photo', key: 'photo',
      render: (data, record) => (<>
        <Image
          width={50}
          src={record.photo ? 'https://e-sangha.atomsoft.co/uploads/monks/' + record.photo : 'https://e-sangha.atomsoft.co/uploads/monks/monk-1749225185584-898797282.png'}
        />
      </>)
    },
    { title: 'ชื่อ', dataIndex: 'first_name_th', key: 'first_name_th' },
    { title: 'นามสกุล', dataIndex: 'last_name_th', key: 'last_name_th' },
    { title: 'ฉายา', dataIndex: 'dharma_name', key: 'dharma_name' },
    { title: 'วัด', dataIndex: 'temple_name', key: 'temple_name' },
    {
      title: 'การจัดการ',
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => navigate(`/monks/${record.monkId}`)}>
            ดูรายละเอียด
          </Button>
          <Button type="link" onClick={() => handleEdit(record)}>
            แก้ไข
          </Button>
          <Popconfirm title="ยืนยันการลบ?" onConfirm={() => handleDelete(record.monkId)}>
            <Button danger>ลบ</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  //การค้นหาแบบตัดคำแยกค้นหาและต้องมีทุกคำ เช่น สมชาย ใจดี
  const filteredMonks = monks.filter((monk) => {
    const keywords = searchText.toLowerCase().split(' ').filter(Boolean); // แยกคำ
    const combined = `${monk.first_name_th} ${monk.last_name_th} ${monk.dharma_name} ${monk.temple_name}`.toLowerCase();

    // ต้องมีทุกคำใน combined
    return keywords.every((keyword) => combined.includes(keyword));
  });

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
          <Input.Search
            placeholder="ค้นหา ชื่อพระ ฉายา หรือชื่อวัด"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 300 }}
            allowClear
          />
          <Button type="primary" onClick={() => setOpenDrawer(true)}>
            เพิ่มพระภิกษุ/สามเณร
          </Button>
        </div>
      </div>

      <Table
        dataSource={filteredMonks}
        rowKey="monkId"
        columns={columns}
        pagination={{
          // pageSize: 5, // จำนวนแถวต่อหน้า
          showSizeChanger: true, // ให้ผู้ใช้เปลี่ยนจำนวนแถวต่อหน้าได้
          pageSizeOptions: ['5', '10', '20', '50', '100'], // ตัวเลือก
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
        }}
      />

      <Drawer
        open={openDrawer}
        onClose={handleCloseDrawer}
        destroyOnHidden={true}
        title={editingMonk ? 'แก้ไขข้อมูลพระ' : 'เพิ่มพระใหม่'}
        width={600}
      >
        <MonkForm initialData={editingMonk} onFinish={handleCloseDrawer} />
      </Drawer>
    </>
  );
};

export default MonksPage;
